enum RoutesEnum {
    Home = '/',
    Browse = '/browse',
    DocumentDetails = '/details/:id',
    SnapDocumentDetails = '/snapDocumentDetails/:id',
    ReadingList = '/lists',
    SharedWithMeList = '/lists/shared',
    Alerts = '/alerts',
    News = '/news',
    NewsArticle = '/news/article/:id',
    Test = '/test-page',
    Unsubscribe = '/unsubscribe/:token'
}

export enum RoutesAriaEnum {
    Library = 1,
    Browse,
    Document,
    ReadingList,
    Alerts,
    News,
    NewsArticle,
    Test
}

export default RoutesEnum;
